<template>
  <modal-card :ctrl="ctrl">
    <div slot="body">
      <div class="buttons">
        <div @click="ctrl.active = false" class="button is-link flex-pull-right">
          <v-color-icon name="close"></v-color-icon>
          <span>关闭</span>
        </div>
      </div>
      <div class="body">
        <div>
          <label class="label">输入
            <button v-if="supportCopy" :id="'copy-btn-' + _uid" @click="copy(testcase.input)"
                    class="button is-small">
              <i class="fa fa-copy fa-fw is-icon"></i> 复制到剪贴板
            </button>
          </label>
          <div v-if="testcase.show" class="code-editor">
            <ace-editor
                v-if="testcase.input"
                v-model="testcase.input" :height="'100px'"
                :readOnly="true"></ace-editor>
            <div v-else class="card-content">无输入</div>
          </div>
          <span v-else>输入</span>
        </div>
        <div>
          <br>
          <div v-if="testcase.output_file">
            <div class="message is-info">
              <div class="message-body">
                <div v-if="testcase.output_file">
                  请将结果保存到文件: {{ testcase.output_file.name }}
                </div>
              </div>
            </div>

            <template v-if="editMode || (testcase.show && testcase.result && !testcase.hide_output)">
              <div class="card">
                <figure v-if="testcase.result && testcase.result.startsWith('data:image/png;base64,')"
                        class="image">
                  <img :src="testcase.result">
                </figure>
                <ace-editor v-else v-model="testcase.result"
                            :height="'60vh'"
                            :readOnly="true"></ace-editor>
              </div>
            </template>

          </div>
          <div v-else>
            <div class="columns is-marginless">
              <div class="column is-paddingless">
                <label class="label">期望输出
                  <button v-if="supportCopy" :id="'copy-btn-' + _uid" @click="copy(testcase.output)"
                          class="button is-small">
                    <i class="fa fa-copy fa-fw is-icon"></i> 复制到剪贴板
                  </button>
                </label>
                <span></span>
              </div>
              <div class="column is-paddingless">
                <label class="label">你的输出
                  <button v-if="supportCopy" :id="'copy-btn-' + _uid" @click="copy(testcase.result)"
                          class="button is-small">
                    <i class="fa fa-copy fa-fw is-icon"></i> 复制到剪贴板
                  </button>
                </label>
                <span></span>
              </div>
            </div>

            <div class="ace-diff code-editor">
              <div class="ace-ayu-light" id="acediff"></div>
            </div>
            <p class=" is-text-info">蓝色背景表明你的输出与期望输出存在不一致之处。如果看起来「完全一致」，注意检查是否有多余「空格」</p>
            <p class=" is-text-danger">红色背景标明这是一个「中文字符」，注意输出符合题意的「中英文标点」（初学者注意切换中英文输入法）</p>
            <p class="">有时候你可能因为在 <code>input()</code> 中增加提示参数（例如 <code>input('请输入一个整数:')</code>）导致输出结果不符合题意</p>

          </div>
        </div>

      </div>
    </div>
  </modal-card>
</template>

<script>

import 'ace-diff/dist/ace-diff.min.css'
import ModalCard from '@/common/layout/ModalCard'
import AceEditor from '@/common/ace_editor/AceEditor'

import ClipboardJs from 'clipboard'
import AceDiff from 'ace-diff'
import '@/common/ace_editor/theme/ayu-light.css'

export default {
  props: { 'ctrl': {}, 'testcase': {}, 'editMode': { default: false } },
  data () {
    return {
      tab: 1,
      code: '',
      diff: null,
      clipboard: null,
      supportCopy: ClipboardJs && ClipboardJs.isSupported()
    }
  },
  watch: {
    'testcase': {
      handler () {
        if (this.diff) {
          this.setDiff()
        }
      },
      immediate: true,
      deep: true
    },
    'ctrl.active' (value) {
      if (!value && this.diff) {
        this.diff.destroy()
        this.diff = null
      } else if (value && !this.diff) {
        this.loadDiff()
      }
    }
  },
  mounted () {
    this.ctrl.manualClose = true
    this.clipboard = new ClipboardJs('#copy-btn-' + this._uid, {
      text: () => {
        return this.code
      }
    })
  },
  methods: {
    copy (value) {
      this.code = value
    },
    loadDiff () {
      if (!AceDiff) return
      if (this.testcase.output_file) return
      if (!document.getElementById('acediff')) return
      this.diff = new AceDiff({
        element: '#acediff',
        diffGranularity: 'specific',
        left: {
          content: '',
          editable: false,
          copyLinkEnabled: false
        },
        right: {
          content: '',
          editable: false,
          copyLinkEnabled: false
        }
      })

      this.editorOutput = this.diff.getEditors().left
      this.editorResult = this.diff.getEditors().right

      this.editorOutput.setFontSize('16px')
      this.editorResult.setFontSize('16px')

      this.setDiff()

      this.editorResult.clearSelection()
      this.editorOutput.clearSelection()
    },
    setDiff () {
      if (!this.diff) return

      const editors = this.diff.getEditors()
      if (this.editMode || (this.testcase.show && !this.testcase.hide_output)) {
        editors.left.setValue(this.testcase.output || '')
      } else {
        editors.left.setValue('期望输出隐藏')
      }
      editors.right.setValue(this.testcase.result || '')
    }
  },
  components: { ModalCard, AceEditor }
}
</script>
<style lang="stylus" scoped>
.body {
  padding: 1.5rem;
  height: 75vh;
  overflow: auto;
}

.buttons {
  padding: 1rem;
  background: $neBg;
}

.ace-diff {
  position: relative;
  height: 400px;
  width: 100%;
  font-size: 1rem;
}

.code-editor {
  border: 1px solid #dddddd;
}
</style>
